import { NewDropDown } from "components/ui/DropDown";
import { FC, useRef, useState } from "react";

import { useOnClickOutside } from "usehooks-ts";

import cn from "utils/cn";

type Props = {
  anchorProps?: any;
  children: any;
  scrollable?: boolean;
  hasMenuFullWidth?: boolean;
  [key: string]: any;
};

const MoreContentDropDown: FC<Props> = ({
  anchorProps,
  children,
  hasMenuFullWidth = false,
  position,
  dropdownIconClassName,
  ...args
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useOnClickOutside(args.containerRef || dropdownRef, () => {
    if (isOpen) setIsOpen(false);
  });

  return (
    <NewDropDown ref={dropdownRef}>
      <NewDropDown.Anchor
        variant={"secondary"}
        onClick={() => setIsOpen(!isOpen)}
        hasChevron={false}
        {...anchorProps}
        className={cn(
          "!min-h-[35px] sm:!min-h-[48px]",
          anchorProps?.className,
          { "!bg-c-gray-800": isOpen },
        )}
      >
        {anchorProps.children || (
          <span>
            <svg
              width="24"
              height="24"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className={dropdownIconClassName}
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 3H9V6H12V3ZM9 9H12V12H9V9ZM9 15H12V18H9V15Z"
                fill="#535353"
              />

              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 3H9V6H12V3ZM9 9H12V12H9V9ZM9 15H12V18H9V15Z"
                fill="white"
              />
            </svg>
          </span>
        )}
      </NewDropDown.Anchor>

      <NewDropDown.Menu
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        pos={position}
        variant="dark"
        hasPadding
        scrollable
        {...args}
        onClick={(e, menu) => {
          menu.focus();
          menu.tabIndex = "-1";
          if (args.onClick) args.onClick(e);
        }}
        hasMenuFullWidth={hasMenuFullWidth}
        onClickOutside={() => {}}
      >
        {typeof children === "function"
          ? children(() => setIsOpen(false))
          : children}
      </NewDropDown.Menu>
    </NewDropDown>
  );
};

export default MoreContentDropDown;
